module.exports = __webpack_public_path__ + "img/spaceAvatar.4301cfd2.png";